import { GoToActions } from "src/pageDefinitions/types";
import {
  setGlobalExitAction,
  clearGlobalExitAction,
} from "src/utils/redux/slices/globalExitConfiguration";
import getStore from "src/utils/redux/store";

export function enableGlobalExit(exitAction: GoToActions) {
  getStore().dispatch(setGlobalExitAction(exitAction));
}

export function disableGlobalExit() {
  getStore().dispatch(clearGlobalExitAction());
}

export function isGlobalExitEnabled() {
  const state = getStore().getState();
  return state.globalExitConfiguration.enabled;
}

export function getGlobalExitAction(): GoToActions | null {
  const state = getStore().getState();
  return state.globalExitConfiguration.exitAction || null;
}
